import { CanActivateFn, Router } from "@angular/router";
import { inject, Injectable } from "@angular/core";
import { StoreService } from "../services/store.service";
import { UNAUTHORIZED_URL } from "../config/url.config";
import { PermissionRole } from "../config/permission.config";
import { ConnectionStatusService } from "../services/connection-status.service";
import { take, tap } from "rxjs";
import { AppInitService } from "../services/app-init.service";

@Injectable({
  providedIn: 'root'
})
class PermissionsService {

  constructor(
    private _store: StoreService,
    private _router: Router,
    private _connectionStatusService: ConnectionStatusService,
    private _appInitService: AppInitService
  ) {
    this._connectionStatusService.networkStatus$.pipe(
      take(1),
      tap(isOnline => this._appInitService.setPermissions(isOnline))
    ).subscribe();

  }

  hasAccessRole() {
    if (this._store.permissions.includes(PermissionRole.ACCESS)) {
      return true;
    }

    void this._router.navigate([UNAUTHORIZED_URL])
    return false;
  }
}

export const AdminGuard: CanActivateFn = (): boolean => {
  return inject(StoreService).isAdmin();
}

export const ReportsGuard: CanActivateFn = (): boolean => {
  return inject(StoreService).canSeeReports();
}

export const MapGuard: CanActivateFn = (): boolean => {
  return inject(StoreService).canSeeMap();
}

export const OrdersGuard: CanActivateFn = (): boolean => {
  return inject(StoreService).canSeeOrders();
}

export const CreateOrdersGuard: CanActivateFn = (): boolean => {
  return inject(StoreService).hasTaskReleaseRole();
}

export const DefectsGuard: CanActivateFn = (): boolean => {
  return inject(StoreService).canSeeDefects();
}

export const TasksGuard: CanActivateFn = (): boolean => {
  return inject(StoreService).canSeeTasks()
}

export const DataGuard: CanActivateFn = (): boolean => {
  return inject(StoreService).canSeeData()
}
export const AccessGuard: CanActivateFn = () => {
  return inject(PermissionsService).hasAccessRole();
}
